export default {
  zh: {
    reportSource: '数据来源: {name}',
    labels: {
      sum: '{value}的和',
      avg: '{value}的平均数',
      group: '{value}',
      count: '总条数',
    }
  },
  en: {
    reportSource: 'Data Source: {name}',
    labels: {
      sum: 'Sum of {value}',
      avg: 'Average of {value}',
      group: '{value}',
      count: 'Count',
    }
  }
};



// WEBPACK FOOTER //
// ./src/views/DashboardSettings_Slot/components/Table/i18n.js